<template>
  <div class="formPosition">
    <loading v-if="isLoading" />
    <v-progress-linear
      style="margin: 0 auto; height: 10px"
      :indeterminate="isLoading"
      v-show="isLoading"
    ></v-progress-linear>
    <v-data-table
      :headers="headers"
      :items="estudantes"
      :search="searchInDb"
      sort-by="data_"
      class="elevation-3"
    >
      <template v-slot:top>
        <v-toolbar flat style="margin:auto;" color="white">
          <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Minhas Solicitações de cadastro de anos anteriores</v-toolbar-title>
          <v-divider class="mx-8" inset vertical></v-divider>
          
          <!--  search  -->
          <div
            v-if="$store.state.hasMessage && cor == 'red'"
            :class="$store.state.classMessage"
          >
            {{ $store.state.textMessage }}
          </div>

          <div class="flex-grow-1"></div>
          <v-btn
            v-if="searchInDb"
            @click="initialize(searchInDb)"
            text
            icon
            color="green"
          >
            <v-icon>cached</v-icon>
          </v-btn>
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa por nome , Bilhete de identidade ou Número de matricula"
            single-line
            hide-details
          ></v-text-field>
          <v-divider class="mx-8" inset vertical></v-divider>
          <!-- end  search  -->
        </v-toolbar>
      </template>

      

      <template v-slot:item.ord="{ item }">
         <span style="font-weight:bold;">{{estudantes.indexOf(item)+1}}.</span>
      </template>
    
      <template v-slot:item.action="{ item }">
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon color="green darken-3" size="25">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="viewRequest(item)">
        <v-list-item-icon>
          <v-icon small color="green">mdi-eye</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <span small>Visualizar Solicitação</span>
        </v-list-item-content>
      </v-list-item>

       <v-list-item  v-if="item.status_2 === '0' || item.status_2 === '3' && role != 'ROLE_DIR'" @click="editRequest(item)">
        <v-list-item-icon>
          <v-icon small color="info">mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <span >Editar Solicitação</span>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>



      <template v-slot:no-data>
        <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

        Clica em + para adicionar novo estudante
      </template>
     <template v-slot:item.situacao="{ item }">
        <v-chip small v-if="item.status_2 === '0'" color="red" dark>
          <v-icon small left>mdi-close-circle</v-icon>
          Rejeitado
        </v-chip>
        <v-chip small v-else-if="item.status_2 === '1'" color="orange" dark>
          <v-icon small left>mdi-clock</v-icon>
          Pendente
        </v-chip>
        <v-chip small v-else-if="item.status_2 === '2'" color="green" dark>
          <v-icon small left>mdi-check-circle</v-icon>
          Aprovada
        </v-chip>
        <v-chip small v-else-if="item.status_2 === '3'" color="blue" dark>
          <v-icon small left>edit</v-icon>
          Rascunho
        </v-chip>
      </template>

    </v-data-table>

     <v-dialog v-model="dialog" max-width="800px">
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center">
      <span>Detalhes da Solicitação</span>
      <v-btn icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-tabs v-model="tab" background-color="#006699" dark>
      <v-tab key="info">Informações Gerais</v-tab>
      <v-tab key="notas">Notas do Certificado</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Aba Informações Gerais -->
      <v-tab-item key="info">
        <v-card-text>
          <v-list dense>
            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Nome do Estudante</v-list-item-title>
                <v-list-item-subtitle>{{ (editedItem === null) ? '' : editedItem.nome }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Ano de Conclusão</v-list-item-title>
                <v-list-item-subtitle>{{ (editedItem === null) ? '' : editedItem.anoLectivo }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-school</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Curso</v-list-item-title>
                <v-list-item-subtitle>{{ (editedItem === null) ? '' : editedItem.curso }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Instituição</v-list-item-title>
                <v-list-item-subtitle>{{ (editedItem === null) ? '' : editedItem.instituicaodescricao }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <!-- Autor da solicitação -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-account-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Autor da Solicitação</v-list-item-title>
                <v-list-item-subtitle>{{ (editedItem === null) ? '' : editedItem.autor }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <!-- Data da solicitação -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-calendar-clock</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">Data da Solicitação</v-list-item-title>
                <v-list-item-subtitle>{{ (editedItem === null) ? '' : editedItem.data_criacao }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
          </v-list>
        </v-card-text>
      </v-tab-item>

      <!-- Aba Notas do Certificado -->
      <v-tab-item key="notas">
        <v-card-text>
          <v-data-table
            :headers="notasHeaders"
            :items="notasCertificado"
            dense
            :items-per-page="30"
            hide-default-footer
            class="elevation-1 custom-table"
          >
            <template v-slot:item.ord="{ item }">
              <span class="ordem">{{ notasCertificado.indexOf(item) + 1 }}</span>
            </template>

            <template v-slot:item.nota="{ item }">
              <span class="nota">{{ item.nota }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>

    <!-- Botões de Ação -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error"   v-if="editedItem.status_2 === '1' && (role === 'ROLE_DIR' ||  role === 'ROLE_ADM')" @click="rejeitarSolicitacao">
        <v-icon left>mdi-cancel</v-icon> Rejeitar 
      </v-btn>
      <v-btn color="success" v-if="editedItem.status_2 === '1' && (role === 'ROLE_DIR' ||  role === 'ROLE_ADM')" @click="aceitarSolicitacao">
        <v-icon left>mdi-check-circle</v-icon> Aprovar
      </v-btn>
      <v-btn color="primary" @click="dialog = false">
        <v-icon left>mdi-close</v-icon> Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { mask } from "vue-the-mask";
import Swal from 'sweetalert2';
const ls = require("local-storage");
export default {
  directives: { mask },
  components: {
    loading: () => import("../../components/loading.vue")
  },
  data: () => ({
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    datebi: null,
    date: null,
    descricao: "Nº do Bi",
    valid: true,
    menu: false,
    menubi: false,
    habilitaBi: false,
    startDate: null,
    anolectivoSelected: ls.get("anolectivo"),
    cursos: [],
    anolectivos: [],
    editedItem: null,
    notasCertificado:[],
    dialog: false,
    isLoading: true,
    turmasAll: [],
    mascara: "#########-AA-###",
    turmasFiltered: [],
    municipiosAll: [],
    tab:0,
    cor: "",
    municipiosFiltered: [],
    foto_parte1: "http://restrito.esaudeluanda.com:7000/config/IMS/file/",
    foto_parte2: "-foto.jpg",
    provincias: [],

    searchInDb: "",
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: "top",
    text: "mensagem nao setada.",
    //  timeout: 4000,

    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 50 || "O máximo número de carácters atigidos",

      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],
    ruleBI: [
      (value) => value.length === 16 || "Minimo de caracteres exigido( 16 ).",
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      (value) => value.length <= 50 || "O máximo número de carácters atigidos",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    headers: [
      { text: "Ord.", value: "ord" },
       {
        text: "Nome",
        align: "left",
        sortable: false,
        value: "nome",
      },

      { text: "Bilhete de Identidade / Outro documento", value: "bi" },
       { text: "Curso", value: "curso" },
       { text: "Anolectivo", value: "anoLectivo" },
       { text: "Estado", value: "situacao" },
      { text: "Data de Cadastro/Moficação", value: "data_" },
      { text: "Observação Ims", value: "observacaoIms" },
      { text: "Instituicao", value: "instituicaodescricao" },
      { text: "Actions", value: "action", sortable: false },
    ],

     notasHeaders: [
      { text: "Ord.", value: "ord" },
      { text: "Disciplina", value: "disciplina" },
      { text: "Nota", value: "nota" },
     ],

    msg: "",
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {
      pkPessoa: 0,
      bi: null,
      idPessoa: "",
      idMunicipio: null,
      idPerfil: null,
      nome: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      nomedopai: "",
      nomedamae: "",
      dataemissaobi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: "",
      curso: null,
      turma: null,
      autor: ls.get('nomeUsuario')
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: "",
      bi: "",
      idMunicipio: null,
      idPerfil: null,
      nome: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      nomedopai: "",
      nomedamae: "",
      dataemissaobi: "",
      ResidenteEm: "",
      instituicao: "",
      instituicaodescricao: "",
      curso: null,
      turma: null,
      autor: ls.get('nomeUsuario')
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Inser novo Estudante"
        : "Editar dados de Estudante";
    },

    role(){ 
      return ls.get('role')
    },
    idclasse() {
      return this.$store.state.idclasse;
    },
    computeddatanascimento() {
      return this.editedItem.datanascimento
        ? moment(this.editedItem.datanascimento).format("dddd, MMMM Do YYYY")
        : "";
    },
    computedDateFormattedDatefns() {
      return this.date ? format(this.date, "dddd, MMMM Do YYYY") : "";
    },
    textMessage() {
      return this.$store.state.textMessage;
    },
    classMessage() {
      return this.$store.state.classMessage;
    },
    hasMessage() {
      return this.$store.state.hasMessage;
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    estudantes() {
      this.isLoading = false;
      this.$store.state.isloading = false;
    },
     
  },

  created() {
    
    this.initialize();
   },

  methods: {
    async initialize(searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"find":"all"}';
        } else {
          payload = '{"find":"' + searchInDb + '"}';
        }

        this.isLoading = true;
        this.estudantes = await axios
          .get(
            "/minhas-solicitacoes/" + payload 
          )
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },  
     
    async viewRequest ( item ){
      this.editedItem= item
      this.notasCertificado = await this.carregaNotas()
      this.dialog = true
    },

    async aceitarSolicitacao() {
      
      let result = await axios.post('/AceitarSolicitacaoCertificado',{dados: this.editedItem}).then((res)=>res.data);
      
       if(result.affectedRows >= 1){
          this.dialog = false
          Swal.fire('Informação','Solicitação de preparação de certificado aprovada com sucesso','success')
          this.initialize()
       }else 
         Swal.fire('Informação','Ocorreu um erro ao tentar aprovar a solicitação','error')
        
    },

    async editRequest( item ){

       this.$store.state.objSolicitacao = item
       this.$router.push('/estudante/solicitar-certificao-fora-epoca');
    },

           
         async rejeitarSolicitacao() {
          this.dialog = false
    const { value: observacao } = await Swal.fire({
        title: "Rejeitar Solicitação",
        input: "textarea",
        inputLabel: "Motivo da Rejeição",
        inputPlaceholder: "Digite o motivo da rejeição...",
        inputAttributes: {
            "aria-label": "Digite o motivo da rejeição"
        },
        showCancelButton: true,
        confirmButtonText: "Rejeitar",
        cancelButtonText: "Cancelar"
    });

    if (observacao) {
        // Adiciona a observação ao objeto antes de enviar
        let dados = { ...this.editedItem, observacao };

        try {
            let result = await axios.post("rejeitarSolicitacaoCertificado", dados).then((res)=>res.data);
            if(result.affectedRows >= 1)
             {
                 Swal.fire("Rejeitado!", "A solicitação foi rejeitada com sucesso.", "success");
                 this.initialize()
             } 
            else
              Swal.fire("Erro!", "Houve um problema ao rejeitar a solicitação.", "error");
        } catch (error) {
            Swal.fire("Erro!", "Houve um problema ao rejeitar a solicitação.", "error");
        }
    }  
    

      },

     async carregaNotas() {
      try {
      
         return await axios
          .post(
            "/obterNotasSolicitacaoCertificado",{matricula: this.editedItem.idmatricula_temp} 
          )
          .then((res) => res.data);
       } catch (error) {
        Swal.fire('Informação','Ocorreu um erro ao carregar as notas','error')
      }
    },  
    
    
    
  },
};
</script>
<style scoped>
.bg {
  color: green;
  background: red;
}

.custom-table {
  font-size: 13px; /* Reduz o tamanho da fonte para melhor compactação */
}

.custom-table .v-data-table-header {
  background-color: #f5f5f5; /* Cor suave para destacar o cabeçalho */
  font-weight: bold;
}

.custom-table .v-data-table__wrapper tr {
  border-bottom: 1px solid #e0e0e0; /* Linha de separação mais sutil */
}

.custom-table .v-data-table__wrapper td {
  padding: 5px 10px; /* Reduzir padding das células */
}

.ordem {
  font-weight: bold;
  color: #1976d2; /* Azul para destacar a numeração */
}

.nota {
  font-weight: bold;
  color: #4caf50; /* Verde para destacar a nota */
}

</style>
